/**
 * The loyalty club (release 1.63, club A): the public registration and card pages, the till, the owner's screens.
 * The rules text itself is NOT here — it is legal text, Georgian only, in lib/club-rules.ts.
 */
export const club = {
  // the registration page (/club/:code)
  'club.reg.title': 'მყიდველთა კლუბი',
  'club.reg.lead': 'დარეგისტრირდით და ყოველ ყიდვაზე დაგერიცხებათ ბონუსი. ბარათი თქვენს ტელეფონში იქნება — QR კოდი.',
  'club.reg.name': 'სახელი და გვარი',
  'club.reg.phone': 'ტელეფონის ნომერი',
  'club.reg.email': 'იმეილი',
  'club.reg.emailHint': 'იმეილზე მოვა დასტურის კოდი და ბარათის ბმული. სარეკლამო წერილი არ მოვა.',
  'club.reg.consent': 'ვეთანხმები კლუბის წესებს',
  'club.reg.rules': 'წესების ნახვა',
  'club.reg.send': 'კოდის მიღება',
  'club.reg.sent': 'თუ მონაცემები სწორია, 6-ნიშნა კოდი გამოგეგზავნათ იმეილზე.',
  'club.reg.code': 'კოდი იმეილიდან',
  'club.reg.confirm': 'დადასტურება',
  'club.reg.again': 'ახალი კოდის მოთხოვნა',
  'club.reg.fix.name': 'ჩაწერეთ სახელი.',
  'club.reg.fix.phone': 'ჩაწერეთ ტელეფონის ნომერი (მაგ. 599 12 34 56).',
  'club.reg.fix.email': 'ჩაწერეთ სწორი იმეილი.',
  'club.reg.fix.consent': 'მონიშნეთ, რომ ეთანხმებით წესებს.',
  'club.reg.fix.human': 'დაელოდეთ შემოწმებას (Cloudflare) და სცადეთ ისევ.',
  // the card page (/c/:token)
  'club.card.title': 'კლუბის ბარათი',
  'club.card.show': 'სალაროში აჩვენეთ ეს QR კოდი',
  'club.card.bonus': 'ბონუსი: ₾{amount}',
  'club.card.member': 'კლუბის წევრი {until}',
  'club.card.toGo': 'კლუბამდე ამ თვეში აკლია ₾{amount}',
  'club.card.replace': 'ბარათის შეცვლა',
  'club.card.replaceLead': 'ბარათი დაკარგეთ ან სხვამ ნახა? იმეილზე მოგივათ კოდი, ძველი ბარათი მაშინვე გაუქმდება და მიიღებთ ახალს.',
  'club.card.replaceSend': 'კოდის გაგზავნა',
  'club.card.replaceSent': 'კოდი გამოგეგზავნათ ბარათის იმეილზე.',
  'club.card.replaced': 'ბარათი შეცვლილია — იხილეთ იმეილი',
  'club.card.keep': 'შეინახეთ ეს გვერდი (მაგ. მთავარ ეკრანზე) — ვინც ბმულს ფლობს, ბარათითაც ისარგებლებს.',
  // shared answers
  'club.err.CLUB_CODE_BAD': 'ეს რეგისტრაციის ბმული აღარ მოქმედებს — ჰკითხეთ მაღაზიას ახალი.',
  'club.err.CLUB_OFF': 'ამ მაღაზიის კლუბი ახლა გამორთულია.',
  'club.err.CLUB_CODE_WRONG': 'კოდი არასწორია. სცადეთ ისევ.',
  'club.err.CLUB_CODE_EXPIRED': 'კოდს ვადა გაუვიდა ან ბევრჯერ იყო ცდა — მოითხოვეთ ახალი.',
  'club.err.CLUB_CARD_UNKNOWN': 'ბარათი ვერ მოიძებნა.',
  'club.err.club_unconfigured': 'რეგისტრაცია დროებით მიუწვდომელია.',
  'club.err.club_turnstile': 'შემოწმება ვერ გაიარა — განაახლეთ გვერდი და სცადეთ ისევ.',
  'club.err.CLUB_CARD_REVOKED': 'ეს ბარათი შეცვლილია — მყიდველს ახალი ბარათი იმეილზე აქვს.',
  'club.err.CLUB_NOT_THIS_SHOP': 'ეს ბარათი სხვა მაღაზიისაა.',
  'club.err.CLUB_NOT_MEMBER': 'მყიდველი ჯერ კლუბის წევრი არ არის — ფასი შეიცვალა.',
  'club.err.CLUB_PHONE_TAKEN': 'ეს ნომერი უკვე დადასტურებულია სხვა მყიდველზე.',
  'club.err.CLUB_PHONE_BAD': 'მყიდველს სწორი ტელეფონის ნომერი არ აქვს.',
  'club.err.CLUB_EMAIL_TAKEN': 'ეს იმეილი უკვე სხვა ბარათზეა ამ მაღაზიაში.',
  'club.err.CLUB_EMAIL_BAD': 'ჩაწერეთ სწორი იმეილი.',
  'club.err.CLUB_ALREADY_MEMBER': 'ამ მყიდველს ბარათი უკვე აქვს — გაუგზავნეთ ბმული ხელახლა.',
  'club.err.CLUB_HAS_DEBT': 'მყიდველს ნისია აქვს — ჯერ უნდა დაიფაროს.',
  'club.err.CLUB_FORBIDDEN': 'ამის გაკეთება მხოლოდ მფლობელს შეუძლია.',
  'club.err.CLUB_RATE': 'ძალიან ბევრი კოდი გაიგზავნა — სცადეთ ერთ საათში.',
  'club.err.CLUB_NO_CARD': 'ამ მყიდველს ბარათი არ აქვს.',
  'club.err.CLUB_FORM_BAD': 'შეავსეთ სახელი, ნომერი და იმეილი.',
  'club.err.CLUB_OFFLINE': 'ბარათი ახლა ვერ შემოწმდა — ინტერნეტი არ არის.',
  'club.err.CUSTOMER_NOT_FOUND': 'მყიდველი ვერ მოიძებნა.',
  // the till
  'club.till.refusedOff': 'კლუბი ახლახან გამოირთო — ფასი შეიცვალა, ნახეთ ახალი ჯამი.',
  'club.till.refusedMember': 'მყიდველი ამ წუთას კლუბის წევრი არ არის — ფასი შეიცვალა, ნახეთ ახალი ჯამი.',
  'club.till.cardNotHere': 'ეს კლუბის ბარათია — აქ არ გამოიყენება. დაასკანერეთ სალაროს ეკრანზე.',
  'club.till.join': 'კლუბში ჩაწერა',
  'club.till.confirmPhone': 'ნომერი {phone} — დადასტურება',
  'club.till.phoneConfirmed': 'ნომერი დადასტურდა — ახლა ნომრითაც მოიძებნება.',
  'club.till.cardFound': 'კლუბის ბარათი — {name}',
  'club.link.title': 'კლუბში ჩაწერა',
  'club.link.lead': 'მყიდველს იმეილზე მოუვა 6-ნიშნა კოდი. ის კოდს გეტყვით ან თავად აკრეფს — მხოლოდ ამის შემდეგ გაიცემა ბარათი.',
  'club.link.send': 'კოდის გაგზავნა',
  'club.link.sent': 'კოდი გაიგზავნა მყიდველის იმეილზე.',
  'club.link.confirm': 'ბარათის გაცემა',
  'club.link.done': 'ბარათი გაიცა — ბმული მყიდველს იმეილზე გაეგზავნა.',
  // the owner's settings
  'club.set.turnedOn': 'კლუბი ჩაირთო. დააყენეთ თვის ზღვარი და დაბეჭდეთ პოსტერი.',
  'club.set.turnedOff': 'კლუბი გამოირთო — სალარო კლუბის ფასს აღარ მისცემს.',
  'club.set.needsBonus': 'ბონუსი გამორთულია — კლუბის წევრობა ბონუსით ითვლება. ჩართეთ ბონუსი ზემოთ.',
  'club.set.threshold': 'თვის ზღვარი (დაგროვებული ბონუსი)',
  'club.set.thresholdBad': 'ჩაწერეთ თანხა, მაგ. 15 ან 12.50 — ან დატოვეთ ცარიელი.',
  'club.set.thresholdNone': 'ზღვარი არ არის — კლუბის ფასი ჯერ არავის ეკუთვნის. 0 = ყველა ბარათის მფლობელი წევრია.',
  'club.set.thresholdHint': 'ვინც ერთ თვეში ამდენ ბონუსს დააგროვებს, კლუბის წევრია მომდევნო ყიდვიდან მომდევნო თვის ბოლომდე. 0 = ყველა ბარათის მფლობელი.',
  'club.set.saved': 'შენახულია',
  'club.set.poster': 'რეგისტრაციის პოსტერი',
  'club.set.print': 'პოსტერის ბეჭდვა',
  'club.set.rotate': 'რეგისტრაციის კოდის განახლება',
  'club.set.rotateWarn': 'ძველი პოსტერი მაშინვე აღარ იმუშავებს — ახალი უნდა დაბეჭდოთ. უკვე გაცემული ბარათები არ იცვლება.',
  'club.set.rotated': 'კოდი განახლდა — დაბეჭდეთ ახალი პოსტერი.',
  'club.set.makeCode': 'რეგისტრაციის კოდის შექმნა',
  'club.set.popupBlocked': 'ბრაუზერმა ფანჯარა დაბლოკა — დაუშვით pop-up და სცადეთ ისევ.',
  // the product card
  'club.product.label': 'კლუბის ფასი',
  'club.product.hint': '(წევრისთვის)',
  'club.product.bad': 'კლუბის ფასი 0-ზე მეტი და გასაყიდ ფასზე ნაკლები უნდა იყოს (თეთრამდე).',
  // the customers page
  'club.cust.noCard': 'ამ მყიდველს კლუბის ბარათი არ აქვს.',
  'club.cust.joined': 'შემოვიდა',
  'club.cust.viaSelf': 'თავად, პოსტერიდან',
  'club.cust.viaCashier': 'მოლარემ ჩაწერა',
  'club.cust.viaOwner': 'მფლობელმა ჩაწერა',
  'club.cust.status': 'კლუბი',
  'club.cust.notMember': 'ჯერ არ არის წევრი',
  'club.cust.month': 'ამ თვის ბონუსი',
  'club.cust.confirmed': 'დადასტურებულია',
  'club.cust.unconfirmed': 'არ არის დადასტურებული',
  'club.cust.send': 'ბარათის ბმულის გაგზავნა',
  'club.cust.sent': 'ბმული გაიგზავნა მყიდველის იმეილზე.',
  'club.cust.replaceWarn': 'ძველი ბარათი მაშინვე გაუქმდება, ახალი ბმული მყიდველს იმეილზე გაეგზავნება. ბონუსი და წევრობა რჩება.',
  'club.cust.replaced': 'ბარათი შეიცვალა — ახალი ბმული გაიგზავნა.',
  'club.cust.leave': 'კლუბიდან წაშლა',
  'club.cust.leaveWarn': 'წაიშლება სახელი, ნომერი, იმეილი და ბარათი; დაუხარჯავი ბონუსი განულდება. ყიდვები რჩება უსახელოდ. ამის დაბრუნება შეუძლებელია.',
  'club.cust.left': 'მყიდველი წაიშალა კლუბიდან.',
  'club.cust.anonymized': 'ეს მყიდველი წაიშალა კლუბიდან — მისი მონაცემები აღარ ინახება.',
  'club.till.checking': 'კლუბის წევრობა მოწმდება…',
  'club.link.mailFailed': 'კოდი იმეილზე ვერ გაიგზავნა — შეამოწმეთ მისამართი და სცადეთ ისევ.',
  'club.link.doneNoMail': 'ბარათი გაიცა, მაგრამ ბმული იმეილზე ვერ გაიგზავნა — გაუგზავნეთ ხელახლა მყიდველის გვერდიდან.',
  'club.cust.noMail': 'შესრულდა, მაგრამ იმეილი ვერ გაიგზავნა — სცადეთ „ბარათის ბმულის გაგზავნა".',
  'club.err.generic': 'ვერ მოხერხდა. სცადეთ ცოტა ხანში.',
} as const
